import { createSelector, createFeatureSelector } from '@ngrx/store';
import { AuthState } from '../reducers/auth.reducer';

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export const selectIsAuthenticated = createSelector(
  selectAuthState,
  (state: AuthState) => !!state.idToken,
);

export const selectAuthToken = createSelector(
  selectAuthState,
  (state: AuthState) => state.idToken,
);

export const selectRefreshToken = createSelector(
  selectAuthState,
  (state: AuthState) => state.refreshToken,
);

export const selectCurrentUserId = createSelector(
  selectAuthState,
  (state: AuthState) => state.userId,
);

export const selectPreviousUserId = createSelector(
  selectAuthState,
  (state: AuthState) => state.previousUserId,
);

export const selectCustomToken = createSelector(
  selectAuthState,
  (state: AuthState) => state.customToken,
);